"use client"

import dynamic from "next/dynamic"

const OpexaClient = dynamic(
  () => import("@/app/opexa-client").then((module) => module.OpexaClient),
  { ssr: false }
)

export function OpexaShell() {
  return <OpexaClient />
}
